var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6615 0.570312C10.6833 0.570312 0.162109 11.092 0.162109 24.0701C0.162109 37.0483 10.6833 47.5698 23.6615 47.5698C36.6397 47.5698 47.1621 37.0479 47.1621 24.0701C47.162 11.0915 36.6397 0.570312 23.6615 0.570312ZM34.1911 34.599C34.1911 36.176 32.9129 37.4543 31.3362 37.4543H15.9879C14.4106 37.4543 13.1326 36.176 13.1326 34.599V13.5407C13.1326 11.9637 14.4109 10.6854 15.9879 10.6854H28.0344V16.3959H34.1911V34.599ZM29.2534 15.1766V10.6851L34.1911 15.1766H29.2534Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco13);
export default __webpack_public_path__ + "static/media/ico-13.d094fa58209ff26ebdd136835016adcd.svg";
export { ForwardRef as ReactComponent };